export default __webpack_public_path__ + "static/media/medtec.0bd7e5b6.png";